export enum LastMenstrualPeriod {
  WithinTheLastWeek = 'Within the last week',
  OneToTwoWeeksAgo = '1-2 weeks ago',
  TwoToFourWeeksAgo = '2-4 weeks ago',
  MoreThanAMonthAgo = 'More than a month ago',
  PostMenopausal = 'Post-menopausal / No menstrual period',
}
